import { Component, OnInit } from '@angular/core';
import { E5coreUiGenerateDocumentBaseComponent } from './e5core-ui-generate-document-base';

@Component({
  selector: 'e5core-ui-generate-document-material',
  templateUrl: './e5core-ui-generate-document-material.component.html',
  styleUrls: ['./e5core-ui-generate-document-material.component.css'],
  providers: [ {provide: E5coreUiGenerateDocumentBaseComponent, useExisting: E5coreUiGenerateDocumentMaterialComponent }]
})
export class E5coreUiGenerateDocumentMaterialComponent extends E5coreUiGenerateDocumentBaseComponent implements OnInit{
}